import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=f2ff7774&scoped=true&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=f2ff7774&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff7774",
  null
  
)

export default component.exports